import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
// import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import { passengerDetails } from "../actions/main";
import { connect } from "react-redux";
import { postData } from "../utils/common-methods";
import Dialog from "@material-ui/core/Dialog";
import { Config } from "../utils/Config";
import { scrollToSection } from "../utils/common-methods";
import { setCookie, getCookie } from "../utils/cookieManager";
import "../App.scss";

class Passenger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: 0,
      isSnackBarOpen: false,
      isDialogOpen: false,
      CouponApplied: false,
      CouponCode: "",
      travelInsurance: false,
      rtcFareDialog: false
    };
  }

  componentDidMount() {
    if (getCookie("TicketSummaryVisit")) {
      this.props.history.goBack();
    }
    const ticket = this.props.ticketdetailsReducer;
    const TravellerType = this.props.location.state.TravellerType;

    if (ticket.bus.RtcTag !== null && ticket.bus.RtcTag === "APSRTC") {
      this.setState({
        isAPSRTC: true
      });
    }

    const e = this.props.ticketdetailsReducer.email
      ? this.props.ticketdetailsReducer.email
      : getCookie("USEREMAIL");
    const m = this.props.ticketdetailsReducer.mobile
      ? this.props.ticketdetailsReducer.mobile
      : getCookie("USERMOBILE");

    this.setState({
      price: ticket.totalamount,
      travelInsuranceCharge: 0,
      TravellerType,
      email: e,
      mobile: m
    });
  }

  verifyInput = () => {
    console.log("Verifying Input....");

    let pas = this.props.ticketdetailsReducer.passengerdetails;
    let email = this.props.ticketdetailsReducer.email
      ? this.props.ticketdetailsReducer.email
      : getCookie("USEREMAIL");
    let mobile = this.props.ticketdetailsReducer.mobile
      ? this.props.ticketdetailsReducer.mobile
      : getCookie("USERMOBILE");

    var regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (email && regEx.test(email)) {
      if (mobile && mobile.length === 10) {
        for (let i = 0; i < pas.length; i++) {
          if (pas[i].passenger.name !== "" || pas[i].passenger.age !== "") {
            if (!/^([a-z]+\s)*[a-z]+$/i.test(pas[i].passenger.name)) {
              this.updateStateObj(
                true,
                "pname_" + i,
                "Please Enter Text Only "
              );
              scrollToSection(`.Passenger${i}`, 500);
              return false;
            } else if (
              pas[i].passenger.name.length < 3 ||
              pas[i].passenger.name.length >= 16
            ) {
              this.updateStateObj(
                true,
                "pname_" + i,
                "Name should Contain Minimum 3 letters and max 16 letters"
              );
              scrollToSection(`.Passenger${i}`, 500);
              return false;
            } else if (pas[i].passenger.age === "") {
              this.updateStateObj(true, "page_" + i, "Please Enter Age");
              scrollToSection(`.Passenger${i}`, 500);
              return false;
            } else {
              if (
                this.state.TravellerType === 3 &&
                parseInt(pas[0].passenger.age) < 60
              ) {
                this.updateStateObj(
                  true,
                  "page_0",
                  "Enter age Greater than 60 or 60 to avail Concession"
                );
                return false;
              }
            }
          } else {
            this.updateStateObj(true, "pname_" + i, "Please Enter Name");
            this.updateStateObj(true, "page_" + i, "Please Enter Age");
            scrollToSection(`.Passenger${i}`, 500);
            return false;
          }
          if (pas.length - 1 === parseInt(i)) return true;
        }
      } else {
        this.updateStateObj(true, "Mobile", "Please Enter Valid PhoneNumber");
        scrollToSection(".contact-information", 500);
        return false;
      }
    } else {
      this.updateStateObj(true, "Email", "Please Enter Valid Email");
      scrollToSection(".contact-information", 500);
      return false;
    }
  };

  getRTCPrice = () => {
    if (!this.verifyInput()) {
      return;
    }
    this.setState({
      isLoading: true
    });
    const data = this.props.ticketdetailsReducer;
    const bus = data.bus;
    const type = this.props.location.state.TravellerType;
    const boarding = data.boarding;
    const dropping = data.dropping;
    const seat = data.ticketdetails;
    let seats = [];
    for (var i in seat) {
      seats.push(i);
    }
    // console.log(seats);

    const url = `${
      Config.SECURED_API_HOST
    }/api/platform/bus/getFinalAmount?operatorId=${bus.BusTypeId}&serviceId=${
      bus.Id
    }&doj=${bus.DateOfJourney}&source=${boarding.Id}&destination=${
      dropping.Id
    }&childSeats=?&adultSeats=${seats.join()}&concessionId=${type}`;

    fetch(url)
      .then(res => res.json())
      .then(res => {
        console.log(res);
        this.setState({
          rtcFare: res.totalAmount,
          rtcFareDialog: true,
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({ isLoading: false });
        console.log(error);
        this.openSnackBar("Something went Wrong! Please Try again");
      });
  };

  handleChange = (type, i) => event => {
    // debugger;
    let info = this.props.ticketdetailsReducer.passengerdetails;
    let name = type === "pname_" + i ? event.target.value : "";
    let age = type === "page_" + i ? event.target.value : "";
    let gender = type === "pgender_" + i ? event.target.value : "";

    if (type === "email") {
      const regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (regEx.test(event.target.value)) {
        this.updateStateObj(false, "Email", null);
      } else {
        this.updateStateObj(true, "Email", "Please Enter Valid Email");
      }
      this.setState({ email: event.target.value });
      info[0].passenger.email = event.target.value;
      this.props.passengerDetails({
        email: event.target.value,
        passengerdetails: info
      });
    }

    if (type === "number") {
      // debugger;
      if (/^\d+$/.test(event.target.value)) {
        if (event.target.value.length === 10) {
          this.updateStateObj(false, "Mobile", null);
        } else if (event.target.value.length < 10) {
          this.updateStateObj(true, "Mobile", "Please Enter Valid Number");
        }
      } else {
        this.updateStateObj(true, "Mobile", "Please Enter Valid Number");
      }
      this.setState({ mobile: event.target.value });
      info[0].passenger.mobile = event.target.value;
      this.props.passengerDetails({
        mobile: event.target.value,
        passengerdetails: info
      });
    }

    if (type === "pname_" + i) {
      // debugger;
      if (name) {
        if (/^([a-z]+\s)*[a-z]+$/i.test(name)) {
          if (name.length >= 3 && name.length <= 16) {
            this.updateStateObj(false, "pname_" + i, null);
          } else {
            this.updateStateObj(
              true,
              "pname_" + i,
              "Name should Contain Minimum 3 letters"
            );
          }
        } else {
          this.updateStateObj(true, "pname_" + i, "Please Enter Text Only");
        }
      } else {
        this.updateStateObj(true, "pname_" + i, "Please Enter Name");
      }

      info[i].passenger.name = name;
      this.props.passengerDetails({
        passengerdetails: info
      });
      //this.setState({ passangerInfo: info });
    }

    if (type === "page_" + i) {
      if (/^\d+$/i.test(age)) {
        if (parseInt(age) >= 5 && parseInt(age) <= 125) {
          this.updateStateObj(false, "page_" + i, null);
        } else {
          this.updateStateObj(true, "page_" + i, "Enter age Between 5 to 125");
        }
      } else {
        this.updateStateObj(true, "page_" + i, "Enter Number");
      }

      if (this.state.TravellerType === 3 && parseInt(age) < 60) {
        this.updateStateObj(true, "page_" + i, "Enter age Greater than 60");
      }
      info[i].passenger.age = age;
      this.props.passengerDetails({
        passengerdetails: info
      });
    }

    if (type === "pgender_" + i) {
      info[i].passenger.gender = gender;
      gender === "MALE"
        ? (info[i].passenger.title = "Mr")
        : (info[i].passenger.title = "Ms");
      this.props.passengerDetails({
        passengerdetails: info
      });
    }

    if (type === "Coupon") {
      this.setState({
        CouponCode: event.target.value
      });
    }
    if (type === "travelInsurance") {
      this.setState({
        travelInsurance: this.state.travelInsurance ? false : true
        // price: this.state.travelInsurance
        //   ? this.state.price - this.state.travelInsuranceCharge
        //   : this.state.price + this.state.travelInsuranceCharge
      });
    }
  };

  ProceedToPayment = () => {
    if (!this.verifyInput()) {
      return;
    }

    console.log("Blocking Ticket...");
    this.props.passengerDetails({
      passengerdetails: this.state.passangerInfo
    });

    let email = this.props.ticketdetailsReducer.email
      ? this.props.ticketdetailsReducer.email
      : getCookie("USEREMAIL");
    let mobile = this.props.ticketdetailsReducer.mobile
      ? this.props.ticketdetailsReducer.mobile
      : getCookie("USERMOBILE");
    const Journey = this.props.searchQuery;
    const ticketdetails = this.props.ticketdetailsReducer;
    const passenger = ticketdetails.passengerdetails;
    const bus = ticketdetails.bus;
    const boarding = ticketdetails.boarding;
    const dropping = ticketdetails.dropping;
    let userToken = getCookie("USERTOKEN");

    this.setState({
      isLoading: true,
      rtcFareDialog: false
    });

    const couponcode = this.state.CouponCode ? this.state.CouponCode : "";
    let url = "";

    if (passenger[0].passenger.email === "") {
      passenger[0].passenger.email = email;
    }

    if (passenger[0].passenger.mobile === null) {
      passenger[0].passenger.mobile = mobile;
    }

    let blockTicketrequest = {
      availableTripId: bus.Id,
      boardingPointId: boarding.Id,
      source: bus.Source,
      isInsured: this.state.travelInsurance,
      destination: bus.Destination,
      inventoryItems: passenger,
      paymentMode: "CREDIT_CARD",
      couponCode: couponcode
    };

    //checking if user has logged in
    //required  when user wants to pay using wallet
    let authToken = "";
    authToken = userToken ? (authToken = `authToken=${userToken}&`) : "";

    if (bus.RtcTag === "APSRTC") {
      url = `${Config.SECURED_API_HOST}/api/platform/bus/blockTicket?${authToken}dateofJourney=${Journey.doj}&CouponCode=${couponcode}&channel=web&provider=APSRTC`;
      blockTicketrequest = {
        availableTripId: bus.Id,
        boardingPointId: boarding.Id,
        droppingPointId: dropping.Id,
        source: bus.Source,
        isInsured: this.state.travelInsurance,
        destination: bus.Destination,
        inventoryItems: passenger,
        paymentMode: "CREDIT_CARD",
        couponCode: couponcode,
        provider: bus.Provider,
        concessionId: this.props.location.state.TravellerType,
        additionalInfo:
          this.props.location.state.TravellerType === 3
            ? this.props.location.state.GovtId
            : ""
      };
    } else {
      url = `${Config.SECURED_API_HOST}/api/platform/bus/blockTicket?${authToken}dateofJourney=${Journey.doj}&CouponCode=${couponcode}&channel=web`;
    }
    console.log(blockTicketrequest);

    postData(url, blockTicketrequest)
      .then(res => {
        console.log(res);
        if (res.Error === null) {
          this.props.history.push({
            pathname: "/bus-booking-phonepe/ticket-summary",
            state: {
              blockTicketrequest,
              blockRes: res,
              travelInsurance: this.state.travelInsurance
            }
          });
          setCookie("TicketSummaryVisit", true);
        } else {
          this.openSnackBar("Unable to Block Ticket! Please try Again");
          setTimeout(() => {
            this.props.history.goBack();
          }, 5000);
          this.setState({
            isLoading: false
          });
        }
      })
      .catch(error => {
        console.log(error);
        this.openSnackBar("Unable to block Ticket! Please Try Again");
      });
  };

  openSnackBar = message => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({ isSnackBarOpen: true, message: msg });
  };

  handleClose = () => {
    this.setState({ isSnackBarOpen: false });
  };

  ApplyCoupon = () => {
    console.log("Coupon Applying..");
    let email = this.props.ticketdetailsReducer.email
      ? this.props.ticketdetailsReducer.email
      : getCookie("USEREMAIL");
    let mobile = this.props.ticketdetailsReducer.mobile
      ? this.props.ticketdetailsReducer.mobile
      : getCookie("USERMOBILE");
    const { price, CouponCode, CouponApplied } = this.state;

    if (email === "" && mobile.length !== 10) {
      this.updateStateObj(true, "Email", "Please Enter Email");
      this.updateStateObj(true, "Mobile", "Please Enter Mobile Number");
      return;
    } else if (email === "") {
      this.updateStateObj(true, "Email", "Please Enter Email");
      return;
    } else if (mobile.length !== 10) {
      this.updateStateObj(true, "Mobile", "Please Enter Mobile Number");
      return;
    }

    this.setState({
      isDialogOpen: true
    });

    if (CouponCode !== "" && CouponApplied === false) {
      const couponURL = `${Config.SECURED_API_HOST}/api/platform/coupon/applycoupon?couponcode=${CouponCode}&email=${email}&phonenumber=${mobile}&originalFare=${price}`;
      fetch(couponURL)
        .then(res => res.json())
        .then(res => {
          if (res.CouponText !== "Coupon code invalid") {
            this.setState({
              CouponApplied: true,
              coupondata: res,
              price: res.FareAfterDiscount
            });
          } else {
            this.setState({
              CouponApplied: false
            });
            this.openSnackBar("Invalid Coupon Code");
          }
          console.log(res);
        })
        .catch(error => {
          console.log(error);
          this.openSnackBar("Something went Wrong! Please Try Again");
        });
    }
  };

  handleDialogClose = () => {
    this.setState({
      isDialogOpen: false,
      rtcFareDialog: false
    });
  };

  handleDialogOpen = () => {
    this.setState({
      isDialogOpen: true
    });
  };

  updateStateObj = (flag, name, message) => {
    // debugger;
    this.setState({
      [`${name}Err`]: flag,
      [`${name}ErrTxt`]: message
    });
  };

  render() {
    const coupondetails = this.state.coupondata;
    const couponDialog = this.state.CouponApplied ? (
      <Dialog
        open={this.state.isDialogOpen}
        onClose={this.handleDialogClose}
        maxWidth="xl"
        fullWidth
      >
        <div className="fare-details">
          <h3>Coupon Details</h3>
          <hr />
          <Grid container justify="flex-start" className="fare-details-content">
            <Grid container>
              <Grid item xs={5}>
                <span>Coupon</span>
              </Grid>
              <Grid item xs={7}>
                {coupondetails.CouponText}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                <span>Discount</span>
              </Grid>
              <Grid item xs={7}>
                Rs {coupondetails.DiscountOnFare}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                <span>Final Price</span>
              </Grid>
              <Grid item xs={7}>
                Rs {coupondetails.FareAfterDiscount}
              </Grid>
            </Grid>
            <Grid item xs={12} className="text-right">
              <strong
                className="close-dialog-btn"
                onClick={this.handleDialogClose}
              >
                close
              </strong>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    ) : (
      <Dialog
        open={this.state.isDialogOpen}
        onClose={this.handleDialogClose}
        maxWidth="xl"
        fullWidth
      >
        <div className="fare-details">
          <Grid container justify="flex-start" className="fare-details-content">
            <TextField
              id="coupon"
              label="Enter Coupon CODE"
              fullWidth
              type="text"
              name="coupon"
              error={this.state.CouponErr ? this.state.CouponErr : false}
              helperText={
                this.state.CouponErrTxt ? this.state.CouponErrTxt : ""
              }
              margin="normal"
              value={this.state.CouponCode ? this.state.CouponCode : ""}
              onChange={this.handleChange("Coupon")}
            />
            <Grid item xs={12} className="text-right">
              <strong className="close-dialog-btn" onClick={this.ApplyCoupon}>
                Apply Coupon
              </strong>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );

    const rtcPriceConfirm = (
      <Dialog
        open={this.state.rtcFareDialog}
        onClose={this.handleDialogClose}
        maxWidth="xl"
        fullWidth
      >
        <div className="fare-details">
          <h3>Message</h3>
          <hr />
          <Grid container justify="flex-start" className="fare-details-content">
            <Grid item xs={12}>
              <span style={{ fontSize: "14px" }}>
                In order to pay ₹{this.state.rtcFare}. Please Click on the
                Proceed Button.
              </span>
            </Grid>
            <Grid item xs={12} className="text-right">
              <button
                style={{ margin: "5px" }}
                className="btn btn-default"
                onClick={this.handleDialogClose}
              >
                Cancel
              </button>
              <button
                style={{ margin: "5px" }}
                className="btn btn-success"
                onClick={this.ProceedToPayment}
              >
                Proceed
              </button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );

    const header = (
      <div className="header">
        <Grid container justify="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={10}>
            <div className="title">
              <span>Passanger Details</span>
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const pas = this.props.ticketdetailsReducer.passengerdetails;
    //console.log(pas);

    const contactInfo = (
      <div
        className="contact-information"
        style={{ margin: "10px", fontSize: "14px" }}
      >
        To Pay &#8377;{this.state.price}
        <br />
        Contact Information
        <div
          className="container"
          style={{ boxShadow: " 0px 2px 3px #b9b7b7" }}
        >
          <TextField
            label="Email"
            fullWidth
            type="email"
            name="email"
            InputLabelProps={{ style: { fontSize: 14 } }}
            autoComplete="email"
            margin="normal"
            error={this.state.EmailErr ? this.state.EmailErr : false}
            helperText={this.state.EmailErrTxt ? this.state.EmailErrTxt : ""}
            value={this.state.email ? this.state.email : ""}
            onChange={this.handleChange("email")}
          />
          <TextField
            label="PhoneNumber"
            type="number"
            fullWidth
            value={this.state.mobile ? this.state.mobile : ""}
            InputLabelProps={{ style: { fontSize: 14 } }}
            maxLength={10}
            error={this.state.MobileErr ? this.state.MobileErr : false}
            helperText={this.state.MobileErrTxt ? this.state.MobileErrTxt : ""}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">+91</InputAdornment>
              )
            }}
            onChange={this.handleChange("number")}
            margin="normal"
          />
        </div>
      </div>
    );

    const ticket = this.props.ticketdetailsReducer.ticketdetails;
    const passangerInfo = Object.keys(ticket).map((key, i) => {
      // debugger;
      return (
        <div
          style={{ boxShadow: " 0px 2px 3px #b9b7b7", margin: "10px" }}
          key={i}
          className={`Passenger${i}`}
        >
          <div style={{ padding: "4px" }}>
            {i === 0 ? "Primary Passenger" : "Passenger " + i}
            <span style={{ marginLeft: "10px" }}>{"Seat " + key} </span>
          </div>
          <div className="container">
            <TextField
              id="name"
              label="Name"
              className=""
              fullWidth
              value={pas[i].passenger.name ? pas[i].passenger.name : ""}
              name={`pname_${i}`}
              InputLabelProps={{ style: { fontSize: 14 } }}
              error={
                this.state[`pname_${i}Err`]
                  ? this.state[`pname_${i}Err`]
                  : false
              }
              helperText={
                this.state[`pname_${i}ErrTxt`]
                  ? this.state[`pname_${i}ErrTxt`]
                  : ""
              }
              onChange={this.handleChange(`pname_${i}`, i)}
              margin="normal"
              // onBlur={this.validateFields}
            />
            <TextField
              id="name"
              label="Age"
              className=""
              InputLabelProps={{ style: { fontSize: 14 } }}
              fullWidth
              type="number"
              value={pas[i].passenger.age ? pas[i].passenger.age : ""}
              name={`page_${i}`}
              error={
                this.state[`page_${i}Err`] ? this.state[`page_${i}Err`] : false
              }
              helperText={
                this.state[`page_${i}ErrTxt`]
                  ? this.state[`page_${i}ErrTxt`]
                  : ""
              }
              onChange={this.handleChange(`page_${i}`, i)}
              margin="normal"
            />
            <RadioGroup
              aria-label="gender"
              name="gender"
              style={{ display: "block" }}
              name={`pgender_${i}`}
              defaultValue={pas[i].passenger.gender}
              onChange={this.handleChange(`pgender_${i}`, i)}
            >
              <FormControlLabel
                value="MALE"
                control={<Radio color="primary" />}
                label="Male"
                disabled={pas[i].ladiesSeat === "true" ? true : false}
                labelPlacement="end"
              />
              <FormControlLabel
                value="FEMALE"
                control={<Radio color="secondary" />}
                label="Female"
                labelPlacement="end"
              />
            </RadioGroup>
          </div>
        </div>
      );
    });

    const Loader = this.state.isLoading ? (
      <div className="loading fixed">
        <CircularProgress />
      </div>
    ) : (
      ""
    );
    const bottommenu = (
      <div>
        <div className="bottom-fixed-details" style={{ fontSize: "14px" }}>
          {/* <FormControlLabel
            control={
              <Checkbox
                checked={this.state.travelInsurance}
                onChange={this.handleChange("travelInsurance")}
                value="antoine"
              />
            }
            style={{ margin: "0px" }}
            label="Travel Insurance at ₹ 15.0 per passenger"
          /> */}

          <Grid container>
            <Grid item xs={6} className="fare-info">
              {this.state.isAPSRTC ? (
                <div style={{ position: "relative" }}>
                  Coupons Not Applicable
                </div>
              ) : (
                <div
                  style={{ position: "relative", marginTop: "10%" }}
                  onClick={this.ApplyCoupon}
                >
                  <span
                    style={{
                      padding: "10px",
                      color: "green ",
                      fontSize: "14px",
                      fontWeight: "Bold"
                    }}
                  >
                    {this.state.CouponApplied
                      ? "Coupon Applied"
                      : "Apply Coupon"}
                  </span>
                  <i className="material-icons">help_outline</i>
                </div>
              )}
            </Grid>
            <Grid item xs={6}>
              <div
                variant="contained"
                style={{ padding: "2rem" }}
                className="ctkt-btn-success-bottom"
                onClick={
                  //this.state.isAPSRTC ? this.getRTCPrice : this.ProceedToPayment
                  this.ProceedToPayment
                }
              >
                CONTINUE
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );

    return (
      <div className="bus-booking">
        {header}
        {contactInfo}
        {Loader}
        {couponDialog}
        {rtcPriceConfirm}
        {/* <div>Passenger Information</div> */}
        <div style={{ marginBottom: "100px", fontSize: "14px" }}>
          <span style={{ marginLeft: "10px" }}>Passenger Information</span>{" "}
          <br />
          {passangerInfo}
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          autoHideDuration={5000}
          message={this.state.message}
        />
        <div>{bottommenu}</div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ticketdetailsReducer: state.ticketdetailsReducer,
    searchQuery: state.searchReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    passengerDetails: res => {
      dispatch(passengerDetails(res));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Passenger);
